import React from "react";
import { TableHead, TableSortLabel, TableCell, TableRow, Tooltip } from "@material-ui/core";
import useStyles from "./styles";

const rows = [
  {
    id: "created_at",
    align: "left",
    disablePadding: false,
    label: "Opened",
    sort: true,
    visible: true
  },
  {
    id: "tender_type",
    align: "left",
    disablePadding: false,
    label: "Payment",
    sort: true,
    visible: true
  },
  {
    id: "summary",
    align: "left",
    disablePadding: false,
    label: "Summary",
    sort: true,
    visible: true
  },
  {
    id: "category",
    align: "left",
    disablePadding: false,
    label: "Category",
    sort: true,
    visible: true
  },
  {
    id: "completed_at",
    align: "left",
    disablePadding: false,
    label: "Completed",
    sort: true,
    visible: true
  }
];

const OrdersTableHead = props => {
  const classes = useStyles();
  const createSortHandler = property => event => {
    props.onSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classes.defaultHeight}>
        {rows.map(row => {
          return (
            <TableCell key={row.id} align={row.align} padding={row.disablePadding ? "none" : "default"} sortDirection={props.order.id === row.id ? props.order.direction : false}>
              {row.sort && (
                <Tooltip title="Sort" placement={row.align === "right" ? "bottom-end" : "bottom-start"} enterDelay={300}>
                  <TableSortLabel active={props.order.id === row.id} direction={props.order.direction} onClick={createSortHandler(row.id)}>
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              )}
            </TableCell>
          );
        }, this)}
      </TableRow>
    </TableHead>
  );
};

export default OrdersTableHead;
